/**
 * Extracts hashtag labels from notification text.
 *
 * @param text - The text to parse for hashtags
 * @returns Array of unique lowercase hashtags without the # prefix
 *
 * @example
 * extractHashtags("Check this #urgent #security issue")
 * // returns ["urgent", "security"]
 */
export function extractHashtags(text: string | undefined): string[] {
  if (!text) {
    return [];
  }

  const hashtagRegex = /#([\w-]+)/g;
  const matches = text.matchAll(hashtagRegex);
  const hashtags = new Set<string>();

  for (const match of matches) {
    // match[1] is the captured group (text after #)
    hashtags.add(match[1].toLowerCase());
  }

  return Array.from(hashtags);
}
